<script>
    //import { props, state } from "svelte";

    let { closeCallback } = $props();
    let isMessageOpen = $state(false);
    let isDialogOpen = $state(false);
    let modalTitle = $state("");
    let modalBody = $state("");

    let modalMessageEl;
    let modalDialogEl;
    let modalMessageInstance;
    let modalDialogInstance;    
    let modalCallback;
    let modalCancelCallback;

    export function dialog(message, title, callback, cancelCallback) {
        modalBody = message;
        modalTitle = title;
        modalCallback = callback;
        modalCancelCallback = cancelCallback;
        
        modalDialogInstance = new bootstrap.Modal(modalDialogEl, {backdrop: true, keyboard: false});
        modalDialogInstance.show();
        isDialogOpen = true;
    }

    export function showMessage(message, title, callback) {
        modalBody = message;
        modalTitle = title;
        modalCallback = callback;
        
        modalMessageInstance = new bootstrap.Modal(modalMessageEl, {backdrop: true, keyboard: false});
        modalMessageInstance.show();
        isMessageOpen = true;
    }

    function toggleDialog() {
        isDialogOpen = !isDialogOpen;
        if (!isDialogOpen){
            modalDialogInstance?.hide();
            if (closeCallback) {
                closeCallback();
            }
        }
    }

    function toggleMessage() {
        isMessageOpen = !isMessageOpen;
        if (!isMessageOpen){
            modalMessageInstance?.hide();
            if (closeCallback) {
                closeCallback();
            }
        }
    }

</script>


<div
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    bind:this={modalMessageEl}
>
    <div class="modal-dialog modal-dialog-centered" role="document" >
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modal-title">{modalTitle}</h5>
                <button type="button" class="btn-close" aria-label="Close" onclick={toggleMessage}></button>
            </div>

            <div class="modal-body">
                {@html modalBody}
            </div>

            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-primary"
                    onclick={() => {
                        if (modalCallback) modalCallback();
                        isMessageOpen = false;
                        modalMessageInstance?.hide();
                        if (closeCallback) closeCallback();
                    }}
                >
                    OK
                </button>
            </div>
        </div>
    </div>
</div>

<div
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    bind:this={modalDialogEl}
>
    <div class="modal-dialog modal-dialog-centered" role="document" >
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modal-title">{modalTitle}</h5>
                <button type="button" class="btn-close" aria-label="Close" onclick={toggleDialog}></button>
            </div>

            <div class="modal-body">
                {@html modalBody}
            </div>

            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-primary"
                    onclick={() => {
                        if (modalCallback) modalCallback();
                        isDialogOpen = false;
                        modalDialogInstance?.hide();
                        if (closeCallback) closeCallback();
                    }}
                >
                    OK
                </button>

                <button
                    type="button"
                    class="btn btn-secondary"
                    onclick={() => {
                        if (modalCancelCallback) modalCancelCallback();
                        isDialogOpen = false;
                        modalDialogInstance?.hide();
                        if (closeCallback) closeCallback();
                    }}
                >
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>
